import React, { useEffect, useState } from "react";
import { Grid, Button, Paper, useMediaQuery, Box, Modal } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import {
  SalesInvoice_getVoucherDetails,
  SalesInvoice_TransTermsDelete,
  SalesInvoice_TransTermsLoadDefault,
  SalesInvoice_TransTermsUpdate,
} from "../../../Server/ApiV2";
import { sTrnTyp } from "../SalesReturnAction";
import { SalesReturnRo } from "../../../Redux/roStore";

const TermsAndConditions = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "Terms And Conditions",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const [rows, setRows] = useState([]);

  const [selectedRowId, setSelectedRowId] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  
  const fTerms = (params) => {
     
    const List = rows?.map((x) => {
      if (x?.id === params.row?.id) {
        x.Terms = params.value;        
        return x;
      } else {
        return x;
      }
    });
    setRows(List);
    params.row.Terms = params.value;

    return params.row;
  };
  const columns = [
    {
      field: "id",
      headerName: "Sr.No",
      width: 100,
      renderCell: (params) => (
        <span>
          {params.value}
          {params.row.id === selectedRowId ? " ➔" : ""}
        </span>
      ),
    },
    {
      field: "Terms",
      headerName: "Terms and Conditions",
      flex: 1,
      editable: true, // Make the text editable
      valueSetter: fTerms, 
    },
  ];

  const handleLoadDefault = async () => {
    const { HeadObject } = SalesReturnRo();

    const payload = {
      v_Process: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
    };
    let resp = await SalesInvoice_TransTermsLoadDefault(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData = resp?.data?.ResultSet;

      setRows(respData);
    } else {
      setRows([]);
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in SalesInvoice_TransTermsLoadDefault "
        );
      }
    }
     
    setSelectedRowId(resp?.data?.ResultSet[0].id);
    setIsEditing(false);
  };

  const handleSave = async () => {
   
    console.log(rows);
    
    const termsArray = rows.map((obj) => ({
      v_SrNo: obj.id,
      v_Terms: obj.Terms,
    }));
    const { HeadObject } = SalesReturnRo();
    const payload = {
      v_Process: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
      termsArray,
    };
    let resp = await SalesInvoice_TransTermsUpdate(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      fAlertToast("SUCCESS", "Successfully Save");
      handleLoad();
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in  TransTermsUpdate "
        );
      }
    }
    setIsEditing(false);
  };

  const handleDelete = async() => {
    const { HeadObject } = SalesReturnRo();

    const payload = {
      v_Process: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
    };
    let resp = await SalesInvoice_TransTermsDelete(
        fcheck_null_undefine_replace_empty(payload)
      );
      if (resp?.status === 200) {
        console.log(resp); 
        handleLoad();
      } else {
        if (resp.response.status == 500) {
          fAlertToast(
            "FAILED",
            resp.response.data.message.msg ||
              "error in  TransTermsDelete "
          );
        }
      }
    // console.log("Delete Payload:", payload);
    // setRows(rows.map((row) => ({ ...row, Terms: "" })));
    // setIsEditing(false);
  };

  const handleRowSelection = (rowData) => {
    setSelectedRowId(rowData.id);
  };

  const handleEditCellChange = (params) => {
    setIsEditing(true);
    const updatedRows = rows.map((row) =>
      row.id === params.id ? { ...row, [params.field]: params.value } : row
    );
    setRows(updatedRows);
    setIsEditing(false); // Enable save button after editing
  };
  const handleLoad = async () => {
    const { HeadObject } = SalesReturnRo();
    const payload = {
      vProcess: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
    };
    let resp = await SalesInvoice_getVoucherDetails(
      fcheck_null_undefine_replace_empty(payload)
    );
    if (resp?.status === 200) {
      console.log(resp);
      let respData = resp?.data?.ResultSet;

      setRows(respData);
    } else {
      setRows([]);
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in  TransTermsLoadDefault "
        );
      }
    }

    setSelectedRowId(resp?.data?.ResultSet[0]?.id || "");
    setIsEditing(false);
  };
  useEffect(() => {
    if (open) {
      handleLoad();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={fCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
          <GCTitleSticky title={xTitle} onClose={fCloseSearchModal} />

          <Paper style={{ padding: "20px" }}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                container
                justifyContent={vMediaQuery?"flex-start" :"flex-end"}
                spacing={2}
              >
                <Grid item >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleLoadDefault}
                    disabled={isEditing}
                    size={"small"}
                  >
                    Load Default
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={isEditing} // Disable save button if not editing
                    size={"small"}
                 >
                    Save
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDelete}
                    disabled={isEditing}
                    size={"small"}
                  >
                    Delete
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={fCloseSearchModal}
                    size={"small"}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <div
                  style={{
                    height: vMediaQuery ? "45vh" : "60vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                      cursor: "pointer",
                    }}
                    rows={rows}
                    columns={columns}
                    onRowClick={(params) => handleRowSelection(params.row)}
                    onCellEditStart={() => setIsEditing(true)}
                    onCellEditStop={() => setIsEditing(false)}
                    onCellEditCommit={() => setIsEditing(false)}
                    hideFooter={rows.length < 100}
                     
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </Modal>
  );
};

export default TermsAndConditions;
